export interface PhaseEntry {
  code: string;
  name: string;
}

export function parsePhaseEntries(text: string): PhaseEntry[] {
  const seen = new Set<string>();

  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/\t/);
      const name = (parts[0] ?? '').trim();
      const code = (parts[1] ?? '').trim();
      return { code, name };
    })
    .filter((e) => e.code && e.name)
    .filter((e) => {
      const key = e.code.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}
